module.exports = __webpack_public_path__ + "img/knu_main1.9fb2aee8.jpg";